import {MINUTE, SECOND} from "@shared/lib/timeUnits";

export const NOTIFICATION_AUTO_INTERVAL = 5 * SECOND;

export const ORDERS_REFRESH_INTERVAL = MINUTE;

// While every address in scope is closed and there are no live orders (night tablets).
export const ORDERS_CLOSED_REFRESH_INTERVAL = 5 * MINUTE;

// An address counts as open this long before its opening and after its closing time (early preorders, late staff).
export const ORDERS_CLOSED_MARGIN = 30 * MINUTE;
